import { Section } from '@/components/shared/Content';
import { Flex } from '@lemonade-hq/cdk';
import styled from 'styled-components';
import { GBSectionTitle, GBSectionParagraph } from './StyledElements';
import type { FC } from 'react';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';

const ContentWrapper = styled(Flex)`
  max-width: 820px;
`;

const BenefitParagraph = styled(GBSectionParagraph)`
  ${MEDIA_QUERIES.tabletAndDesktop`
      white-space: initial;
      text-wrap: balance;
  `}
`;

export interface PublicBenefitProps {
  title: string;
  p1: string;
}

export const PublicBenefit: FC<PublicBenefitProps> = ({ title, p1 }) => {
  return (
    <Section py={[50, 50, 96]} px={20}>
      <GBSectionTitle>{title}</GBSectionTitle>
      <ContentWrapper flexDirection="column" alignItems="center" mt={20}>
        <BenefitParagraph>{p1}</BenefitParagraph>
      </ContentWrapper>
    </Section>
  );
};
